import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    clearAuthData,
    getRefreshToken,
    getUUID,
    setAccessToken,
    setRefreshToken
} from "@shared/lib/utils";
import { API, logoutUser } from "../authSlice";
import { LoginResponse } from "../types";

export const refreshToken = createAsyncThunk<
    LoginResponse,
    any,
    { rejectValue: { message: string } }
>("auth/refreshToken", async (payload: any, thunkAPI) => {
    const TOKEN = getRefreshToken();

    try {
        const response = await fetch(`${API}/v1/auth/get_access_token_by_refresh_token`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Refresh-Token": TOKEN,
                "X-DEVICE-UUID": getUUID()
            }
        });

        let data = await response.json();

        if (response.status === 401) {
            clearAuthData();
            thunkAPI.dispatch(logoutUser());
        }
        if (response.status === 200) {
            const token = data?.data?.accessToken;
            const refreshToken = data?.data?.refreshToken;

            if (!token) {
                throw new Error("No token come from server");
            }

            setAccessToken(token);
            setRefreshToken(refreshToken);

            return data;
        } else {
            throw new Error(data.message);
        }
    } catch (error: any) {
        return thunkAPI.rejectWithValue({ message: error.message });
    }
});